/**
 * The method a passkey answers a second factor as (ECOSYSTEM-EMAIL-001 Q-EE-34 P5): the name the server's method lists
 * carry, answered by the browser's ceremony rather than a code. Declared once for the challenge view and the step-up.
 *
 * @module @puffin-core/mfa-ui/internal/passkeyMethod
 */

export const PASSKEY_METHOD = 'passkey';
